const fields = document.querySelectorAll('input[name="personal_data[emailRepeat]"]');

fields.forEach(field => {
	field.addEventListener('paste', function(e) {
		e.preventDefault();
	});
})